import {
    ActionIcon as MantineActionIcon,
    Tooltip,
    type DefaultMantineColor,
    type MantineSize,
    type StyleProp,
} from '@mantine/core';
import styles from './actionIcon.module.css';

export interface ActionIconProps {
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => Promise<void> | void;
    ref?: React.Ref<HTMLButtonElement>;
    disabled?: boolean;
    loading?: boolean;
    children?: React.ReactNode;
    tooltip?: string;
    size?:
        | number
        | (string & {})
        | MantineSize
        | 'input-xs'
        | 'input-sm'
        | 'input-md'
        | 'input-lg'
        | 'input-xl'
        | undefined;
    c?: StyleProp<DefaultMantineColor> | undefined;
}

export const ActionIcon = ({ children, tooltip, ...props }: ActionIconProps) => {
    const content = tooltip ? (
        <Tooltip label={tooltip} withArrow>
            <MantineActionIcon className={styles.button} variant="subtle" {...props}>
                {children}
            </MantineActionIcon>
        </Tooltip>
    ) : (
        <MantineActionIcon className={styles.button} variant="subtle" {...props}>
            {children}
        </MantineActionIcon>
    );
    return content;
};
